<template>
  <span
    class="mdi inline-block"
    :class="`mdi-${name}`"
  />
</template>
<script setup lang="ts">
defineProps<{
  name?: string;
}>();
</script>
